import { getVisitCapacity } from "../services/VisitCapacity";
import { get_visit } from "../services/VisitRouter";
import { get_generate_note } from "../services/GenerateNote";
import { handleErrorSentry } from "./constants/Error";


// Check status of all elements before 
export async function checkVisitAllowed(addAlert) {
    const visitCapacity = await getVisitCapacity();
    if (visitCapacity && !visitCapacity.can_create) {
        addAlert("You’ve reached the maximum number of daily visits for your subscription. Upgrade for more daily visits", 'danger');
        return false;
    }
    return true;
}

function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

export async function check_visit_status(visit_id, signal) {
    try {
        while (true) {
            await delay(1500)
            if (signal?.aborted) {
                console.log(`Polling canceled (aborted): ${signal.reason}`);
                return;
            }
            const response = await get_visit(visit_id);
            if (response['transcription'] !== null) {
                return response
            }
            await delay(1000);
        }
    } catch (error) {
        handleErrorSentry(error, "tryCatch");
    }
};

export async function check_note_status (visit_id, note_id, signal) {
    try {
        while (true) {
            if (signal?.aborted) {
                console.log("Polling canceled (aborted).");
                return;
            }
            const response = await get_generate_note({visit_id, note_id});
            if (response['generated_result']['value']) {
                return response
            }
            await delay(3500);
        }
    }
    catch(error) {
        handleErrorSentry(error, "tryCatch");
    }
}